<!--<h1>{{IsShowDetail}}</h1>-->
<div *ngIf='!IsShowDetail'>
  <div class="row card-deck">
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form">
      <!--<div class="modal-header">
    <h4 class="modal-title">References</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>-->
      <div class="card-header wh-header">
        References
        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">

        <div class="modal-body">
          <!-- Form actions layout section start -->
          <section id="form-action-layouts">


            <div class="row justify-content-md-center">
              <div class="col-md-12">
                <div class="card">

                  <div class="card-body">
                    <div class="px-3">


                      <div class="form-body">

                        <div class="row">
                          <div class="form-group col-12 mb-2">
                            <label for="eventInput2">Facility Name<span>*</span></label>
                            <input type="text" class="form-control" id="CurrentActorProfessionalReferenceRequest.FacilityName"
                                   [(ngModel)]="CurrentActorProfessionalReferenceRequest.FacilityName"  pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                   name="CurrentActorProfessionalReferenceRequest.FacilityName" placeholder="Facility Name"
                                   required maxlength="30" minlength="1" #FacilityName="ngModel">
                            <small class="form-text text-danger"
                                   *ngIf="(!FacilityName.valid && (FacilityName.dirty || FacilityName.touched) && FacilityName.errors.required )">
                              (Field cannot be left blank)
                            </small>
                            <small class="form-text text-danger"
                                   *ngIf="(!FacilityName.valid && FacilityName.errors.pattern)">(special characters are not allowed)</small>
                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group col-12 mb-2">
                            <label for="eventInput5">Contact Person</label>
                            <input type="text" class="form-control" id="CurrentActorProfessionalReferenceRequest.ContactPerson"
                                   [(ngModel)]="CurrentActorProfessionalReferenceRequest.ContactPerson" name="CurrentActorProfessionalReferenceRequest.ContactPerson"
                                   placeholder="Contact Person" maxlength="40" #ContactPerson="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$">
                            <small class="form-text text-danger"
                                   *ngIf="(!ContactPerson.valid && ContactPerson.errors.pattern)">(special characters are not allowed)</small>
                          </div>
                        </div>


                        <div class="row">
                          <div class="form-group col-12 mb-2">
                            <label for="eventInput2">Contact Person Title</label>
                            <input type="text" class="form-control" id="CurrentActorProfessionalReferenceRequest.ContactPersonTitle"
                                   [(ngModel)]="CurrentActorProfessionalReferenceRequest.ContactPersonTitle"
                                   name="CurrentActorProfessionalReferenceRequest.ContactPersonTitle"
                                   placeholder="Contact Person Title" maxlength="40" #ContactPersonTitle="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$">
                            <small class="form-text text-danger"
                                   *ngIf="(!ContactPersonTitle.valid && ContactPersonTitle.errors.pattern)">(special characters are not allowed)</small>
                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group col-12 mb-2">
                            <label for="eventInput2">Address</label>
                            <input type="text" class="form-control" id="CurrentActorProfessionalReferenceRequest.Address"
                                   [(ngModel)]="CurrentActorProfessionalReferenceRequest.Address"
                                   name="CurrentActorProfessionalReferenceRequest.Address" placeholder="Address" maxlength="100"
                                   #Address="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$">
                            <small class="form-text text-danger"
                                   *ngIf="(!Address.valid && Address.errors.pattern)">(special characters are not allowed)</small>
                          </div>
                        </div>



                        <div class="row">
                          <div class="form-group col-12 mb-2">
                            <label for="eventInput5">Phone Number</label>
                            <input type="text" class="form-control" id="CurrentActorProfessionalReferenceRequest.PhoneNo"
                                   [(ngModel)]="CurrentActorProfessionalReferenceRequest.PhoneNo" pattern="[0-9]{10}"
                                   name="CurrentActorProfessionalReferenceRequest.PhoneNo" placeholder="Phone Number" maxlength="10"   #PhoneNo="ngModel">
                            <small class="form-text text-danger"
                                   *ngIf="(!PhoneNo.valid)">(InValid Phone No)</small>
                          </div>
                        </div>


                        <!--<div class="form-group">
                          <div class="col-md-12">
                            <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn btn-pink btn-block btn-raised">Submit</button>

                          </div>
                        </div>-->


                      </div>



                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!-- // Form actions layout section end -->
        </div>


        <div class="modal-footer">
          <!--<button type="button" class="btn btn-secondary btn-raised" (click)="activeModal.close('Close click')">Close</button>-->
          <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn btn-primary modal-button-center" id="m-last">Submit</button>
        </div>
      </form>
    </div>
    </div>
    </div>
<div *ngIf='IsShowDetail'>
  <div class="row card-deck">
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form">
      
      
        <h5 class="card-header wh-header">
          Reference Detail 
          <button type="button" class="close" data-dismiss="modal"
                  (click)="activeModal.dismiss('Cross click')"
                  aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h5>
        <div class="modal-body">
          <!-- Form actions layout section start -->
          <section id="form-action-layouts">


            <div class="row justify-content-md-center">
              <div class="col-md-12">
                <div class="card">

                  <div class="card-body">
                    <div class="px-3">
                      <!--<detail-grid *ngIf="CurrentActorProfessionalReferencesInfoControllerByCode"
               [columns]="dcolumns" [data]="CurrentActorProfessionalReferencesInfoControllerByCode">

  </detail-grid>-->
                      <div class="row">
                        <div class="form-group col-12 mb-2">
                          <label for="eventInput2">Facility Name :</label>{{CurrentActorProfessionalReferencesInfoControllerByCode.FacilityName}}

                        </div>
                      </div>
                      <div class="row">
                        <div class="form-group col-12 mb-2">
                          <label for="eventInput2">Contact Person Title:</label>{{CurrentActorProfessionalReferencesInfoControllerByCode.ContactPersonTitle}}

                        </div>
                      </div>
                      <div class="row">
                        <div class="form-group col-12 mb-2">
                          <label for="eventInput2">Contact Person :</label>{{CurrentActorProfessionalReferencesInfoControllerByCode.ContactPerson}}

                        </div>
                      </div>
                      <div class="row">
                        <div class="form-group col-12 mb-2">
                          <label for="eventInput2">Address :</label>{{CurrentActorProfessionalReferencesInfoControllerByCode.Address}}

                        </div>
                      </div>
                      <div class="row">
                        <div class="form-group col-12 mb-2">
                          <label for="eventInput2">Phone No :</label>{{CurrentActorProfessionalReferencesInfoControllerByCode.PhoneNo}}

                        </div>
                      </div>


                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!-- // Form actions layout section end -->
        </div>


        <div class="modal-footer">
          <button type="button" class="btn btn-primary close-button modal-button-center" (click)="activeModal.close('Close click')">Close</button>
        </div>
      </div>
</div>
    </div>
  
